import { Divider } from "@msuite/ui/divider";
import { CompareValue } from "@msuite/ui/misc";
import { cn } from "@msuite/ui/utils";
import { getAuditType, getAuditUpdateDiff } from "@msuite/utils/audit";
import { moment } from "@msuite/utils/date";
import type { AuditTable, Tables } from "@msuite/utils/types";
import React, { useMemo } from "react";
import UserCard from "../user-card";

/** Props Interface */
interface AuditCardProps {
	audit: Tables<AuditTable>;
}

export function AuditCard({ audit }: AuditCardProps) {
	const diff = useMemo(() => {
		if ("oldData" in audit && "newData" in audit) {
			return getAuditUpdateDiff(audit.oldData, audit.newData);
		} else {
			return [];
		}
	}, [audit]);

	if (!("operation" in audit)) return null;

	/** Constants */
	const type = getAuditType(audit.operation);

	/** Guard */
	if (type !== "audit-update") return null;

	/** Render */
	return (
		<div className="card v-stack">
			{"changedBy" in audit && audit.changedBy && (
				<div className="justify-between h-stack">
					<UserCard
						userId={audit.changedBy}
						variant="plain"
					/>
					<p className="label">{moment(audit.changedAt).longFormat()}</p>
				</div>
			)}
			<Divider variant="card" />
			<div
				className={cn("gap-1 overflow-hidden text-xs v-stack")}
				style={{
					gridTemplateColumns: "repeat(4, max-content)",
				}}
			>
				{diff.map((_diff, index) => (
					<React.Fragment key={_diff.key}>
						<p>{_diff.key}</p>
						<div className="gap-x-1 grid grid-cols-2">
							<CompareValue
								variant="old"
								width="full"
							>
								{_diff.oldValue}
							</CompareValue>
							<CompareValue
								variant="new"
								width="full"
							>
								{_diff.newValue}
							</CompareValue>
						</div>
						{index !== diff.length - 1 ? <Divider variant="card" /> : null}
					</React.Fragment>
				))}
			</div>
		</div>
	);
}
